export default __webpack_public_path__ + "static/media/react-brands.50f9ae03.svg";